module.exports = __webpack_public_path__ + "img/1.a5f4f330.jpg";